var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"Form",staticClass:"FormContainer",attrs:{"model":_vm.model,"rules":_vm.rules},on:{"validate":_vm.validate2},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }